import { matchPath } from 'react-router-dom';
import { app } from 'cbmms-js/web';

export default { convertToWeappNavType, convertToWeappPage };

function convertToWeappNavType(url, type) {
  if (url.indexOf('/pages/launch') === 0) {
    return 'reLaunch';
  }
  if (url.indexOf('/pages/home/home/') === 0) {
    return url.indexOf('?') === -1 ? 'switchTab' : 'reLaunch';
  }

  return type;
}

function convertToWeappPage(location = '') {
  const { parseLocation, stringifyLocation } = app;

  if (typeof location === 'string') {
    location = parseLocation(location);
  }
  const pathname = location.pathname;
  let match;

  match = matchPath(pathname, { path: '/launch' });
  if (match) {
    let redirectURL = location.searchData['CB-URL'];

    if (redirectURL) {
      redirectURL = convertToWeappPage(redirectURL);

      if (redirectURL && typeof redirectURL !== 'string') {
        redirectURL = redirectURL[0];
      }
    }

    return stringifyLocation({
      pathname: '/pages/launch',
      searchData: { 'CB-URL': redirectURL },
    });
  }

  match = matchPath(pathname, { path: '/orders/:orderId' });
  if (match) {
    return stringifyLocation({
      pathname: '/record-pages/order/order-detail',
      searchData: { orderId: match.params.orderId },
    });
  }

  return [
    stringifyLocation({
      pathname: '/record-pages/web/web',
      searchData: { url: stringifyLocation(location) },
    }),
  ];
}
